// useGeolocation — hook simple para obtener la posición del usuario con watchPosition
import { useEffect, useState, useRef } from "react";

export function useGeolocation(enable = true) {
  const [position, setPosition] = useState(null); // { lat, lng, accuracy }
  const [error, setError] = useState(null);
  const [permission, setPermission] = useState("prompt"); // 'granted' | 'denied' | 'prompt'
  const watchIdRef = useRef(null);

  useEffect(() => {
    if (!enable) return;
    if (!("geolocation" in navigator)) {
      setError("Geolocalización no disponible en este navegador.");
      return;
    }
    const onSuccess = (pos) => {
      setPosition({
        lat: pos.coords.latitude,
        lng: pos.coords.longitude,
        accuracy: pos.coords.accuracy,
      });
      setPermission("granted");
      setError(null);
    };
    const onError = (err) => {
      if (err.code === 1) setPermission("denied");
      setError(err.message || "No se pudo obtener la ubicación.");
    };
    const opts = { enableHighAccuracy: true, timeout: 15000, maximumAge: 30000 };
    watchIdRef.current = navigator.geolocation.watchPosition(onSuccess, onError, opts);
    return () => {
      if (watchIdRef.current != null) {
        navigator.geolocation.clearWatch(watchIdRef.current);
      }
    };
  }, [enable]);

  return { position, error, permission };
}

// Distancia en metros (Haversine)
export function distanceMeters(a, b) {
  if (!a || !b) return null;
  const R = 6371000;
  const toRad = (d) => (d * Math.PI) / 180;
  const dLat = toRad(b.lat - a.lat);
  const dLng = toRad(b.lng - a.lng);
  const lat1 = toRad(a.lat);
  const lat2 = toRad(b.lat);
  const x =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(x));
}

export function formatDistance(m) {
  if (m == null) return "—";
  if (m < 1000) return `${Math.round(m)} m`;
  return `${(m / 1000).toFixed(1)} km`;
}

export function walkingMinutes(m) {
  if (m == null) return null;
  return Math.max(1, Math.round(m / 80)); // ~80 m/min caminando relajado
}
